import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AppState {
  isFirsload: boolean;
  isFullscreen: boolean;
  isRecording: boolean;
  isCorrectingLevel: boolean;
  isRegistering: boolean;
  isCalendarUpdated: boolean;
  isReservationsUpdated: boolean;
  isBotCalled: boolean;
  userHavingCalendar: boolean;
  userTeachingOrganismClass: boolean;
  checkClass: boolean;
  checkClassOrganism: boolean;
  studentNoted: boolean;
  openCoursesHistory: boolean;
  isContributionUpdated: boolean;
  isNewData: boolean;
  quizUpdated: boolean;
  courseUpdated: boolean;
  openAIDrawer: boolean;
  newInvitationSent: boolean;
  newPasswordRequired: boolean;
  isCheckingBooking: boolean;
}

const initialState: AppState = {
  isFirsload: true,
  isFullscreen: false,
  isRecording: false,
  isCorrectingLevel: false,
  isRegistering: false,
  isCalendarUpdated: false,
  isReservationsUpdated: false,
  isBotCalled: false,
  userHavingCalendar: false,
  userTeachingOrganismClass: false,
  checkClass: false,
  checkClassOrganism: false,
  studentNoted: false,
  openCoursesHistory: false,
  isContributionUpdated: false,
  isNewData: false,
  quizUpdated: false,
  courseUpdated: false,
  openAIDrawer: false,
  newInvitationSent: false,
  newPasswordRequired: false,
  isCheckingBooking: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    isFirsload: (state, action: PayloadAction<boolean>) => {
      state.isFirsload = action.payload;
    },
    setFullscreen: (state, action: PayloadAction<boolean>) => {
      state.isFullscreen = action.payload;
    },
    setRecording: (state, action: PayloadAction<boolean>) => {
      state.isRecording = action.payload;
    },
    setCorrectingLevel: (state, action: PayloadAction<boolean>) => {
      state.isCorrectingLevel = action.payload;
    },
    setIsRegistering: (state, action: PayloadAction<boolean>) => {
      state.isRegistering = action.payload;
    },
    setIsCalendarUpdated: (state, action: PayloadAction<boolean>) => {
      state.isCalendarUpdated = action.payload;
    },
    setIsReservationsUpdated: (state, action: PayloadAction<boolean>) => {
      state.isReservationsUpdated = action.payload;
    },
    setIsBotCalled: (state, action: PayloadAction<boolean>) => {
      state.isBotCalled = action.payload;
    },
    setUserHavingCalendar: (state, action: PayloadAction<boolean>) => {
      state.userHavingCalendar = action.payload;
    },
    setUserTeachingOrganismClass: (state, action: PayloadAction<boolean>) => {
      state.userTeachingOrganismClass = action.payload;
    },
    setCheckClass: (state, action: PayloadAction<boolean>) => {
      state.checkClass = action.payload;
    },
    setCheckClassOrganism: (state, action: PayloadAction<boolean>) => {
      state.checkClassOrganism = action.payload;
    },
    setStudentNoted: (state, action: PayloadAction<boolean>) => {
      state.studentNoted = action.payload;
    },
    setOpenCoursesHistory: (state, action: PayloadAction<boolean>) => {
      state.openCoursesHistory = action.payload;
    },
    setIsContributionUpdated: (state, action: PayloadAction<boolean>) => {
      state.isContributionUpdated = action.payload;
    },
    setIsNewData: (state, action: PayloadAction<boolean>) => {
      state.isNewData = action.payload;
    },
    setQuizUpdated: (state, action: PayloadAction<boolean>) => {
      state.quizUpdated = action.payload;
    },
    setCourseUpdated: (state, action: PayloadAction<boolean>) => {
      state.courseUpdated = action.payload;
    },
    setOpenAIDrawer: (state, action: PayloadAction<boolean>) => {
      state.openAIDrawer = action.payload;
    },
    setNewInvitationSent: (state, action: PayloadAction<boolean>) => {
      state.newInvitationSent = action.payload;
    },
    setNewPasswordRequired: (state, action: PayloadAction<boolean>) => {
      state.newPasswordRequired = action.payload;
    },
    setIsCheckingBooking: (state, action: PayloadAction<boolean>) => {
      state.isCheckingBooking = action.payload;
    },
  },
});

/* export const { isFirsload } = appSlice.actions;
export const { setFullscreen } = appSlice.actions;

export default appSlice.reducer; */

export const {
  isFirsload,
  setFullscreen,
  setRecording,
  setCorrectingLevel,
  setIsRegistering,
  setIsCalendarUpdated,
  setIsReservationsUpdated,
  setIsBotCalled,
  setUserHavingCalendar,
  setUserTeachingOrganismClass,
  setCheckClass,
  setCheckClassOrganism,
  setStudentNoted,
  setOpenCoursesHistory,
  setIsContributionUpdated,
  setIsNewData,
  setQuizUpdated,
  setCourseUpdated,
  setOpenAIDrawer,
  setNewInvitationSent,
  setNewPasswordRequired,
  setIsCheckingBooking
} = appSlice.actions;

const { reducer } = appSlice;
export default reducer;
